import { baseColors } from "@Constants/baseStyles"
import { StyleSheet, Platform } from "react-native"

const styles = StyleSheet.create({
    root: { padding: 20, minHeight: 300 },
    title: { textAlign: "center", fontSize: 30 },
    codeFiledRoot: {
        marginTop: 20,
        width: "100%",
        marginLeft: "auto",
        marginRight: "auto"
    },
    cellRoot: {
        width: 45,
        height: 45,
        justifyContent: "center",
        alignItems: "center",
        borderBottomColor: baseColors.black,
        borderBottomWidth: 2
    },
    cellText: {
        color: baseColors.green.primary,
        fontSize: 36,
        textAlign: "center"
    },
    focusCell: {
        borderBottomColor: baseColors.orange.primary,
        borderBottomWidth: 2
    }
})

export default styles
